module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"highTrafficDates":"تاریخ‌های پر تردد"}}')
  delete Component.options._Ctor
}
